import React, { forwardRef, ForwardRefRenderFunction } from 'react';

import { NavigationProvider } from './context';
import Screen from './components/Screen';
import StackRenderer from './components/StackRenderer';
import { NavigationUpdateContextType } from './context/NavigatorContext.interface';

interface NavigatorProps {
    animated?: boolean;
    children: React.ReactNode;
}

interface NavigatorComponentType
    extends React.ForwardRefExoticComponent<NavigatorProps & React.RefAttributes<NavigationUpdateContextType>> {
    Screen: typeof Screen;
}

const NavigatorComponent: ForwardRefRenderFunction<NavigationUpdateContextType, NavigatorProps> = (
    { animated = true, children },
    ref
) => {
    if (!children) {
        return null;
    }

    return (
        <NavigationProvider navigationRef={ref}>
            <StackRenderer animated={animated}>{children}</StackRenderer>
        </NavigationProvider>
    );
};

const Navigator = forwardRef(NavigatorComponent) as NavigatorComponentType;

Navigator.Screen = Screen;

export default Navigator;
